import axios from "axios";

axios.defaults.headers.common["accept"] = "application/json";
// Always read latest token via request interceptor instead of static default
delete axios.defaults.headers.common["authorization"];

const httpService = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_URL_VERSION}`,
  headers: {
    accept: "application/json",
  },
});

// Attach Authorization header dynamically for every request
httpService.interceptors.request.use((config) => {
  const token = localStorage.getItem("cmt_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  } else if (config.headers && "Authorization" in config.headers) {
    delete (config.headers as any)["Authorization"];
  }
  return config;
});
httpService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === "ERR_NETWORK") return Promise.reject(error);
    error.message = error.response?.data.message ?? error.message;
    const errorStatus: number = error.response?.status;
    if (axios.isAxiosError(error) && error.response) {
      const url: string = error.config?.url || "";
      const isAuthEndpoint = url.includes("/admin/login") || url.includes("/admin/verify-login-otp") || url.includes("/admin/force-change-password") || url.includes("/root/forgot-password");

      // Only force redirect on token-related unauthorized (401/403) and not for auth endpoints themselves
      if (!isAuthEndpoint && (errorStatus === 401 || errorStatus === 403)) {
        try {
          localStorage.removeItem("cmt_token");
          localStorage.removeItem("cmt_fullname");
          localStorage.removeItem("cmt_admin");
          localStorage.removeItem("cmt_require_password_change");
        } catch {}
        window.location.replace("/admin/login");
        return; // stop promise chain after hard redirect
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default httpService;
